import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { Pipeline } from '@vendasta/sales-common';
import { Observable, ReplaySubject } from 'rxjs';
import { SubscriptionList } from '@vendasta/rx-utils';
import { FormBuilder, FormGroup } from '@angular/forms';
import { OpportunityValues } from '../../../interface';
import { SALES_UI_CREATE_OPPORTUNITY_CONFIG_TOKEN, SalesUICreateOpportunityConfig } from '../../../tokens';

@Component({
  selector: 'sales-ui-opportunity-pipeline-selector',
  templateUrl: './opportunity-pipeline-selector.component.html',
  styleUrls: ['./opportunity-pipeline-selector.component.scss'],
  standalone: false,
})
export class OpportunityPipelineSelectorComponent implements OnDestroy, OnInit {
  public readonly form: FormGroup;
  private readonly subscriptionList = SubscriptionList.new();
  @Output() pipelineValues = new EventEmitter<OpportunityValues>();
  private readonly selectedPipeline$$ = new ReplaySubject<Pipeline>(1);
  protected readonly selectedPipeline$ = this.selectedPipeline$$.asObservable();
  protected pipelines$: Observable<Pipeline[]>;
  protected cachedPipeline$: Observable<Pipeline>;

  constructor(
    formBuilder: FormBuilder,
    @Inject(SALES_UI_CREATE_OPPORTUNITY_CONFIG_TOKEN) private readonly config: SalesUICreateOpportunityConfig,
  ) {
    this.pipelines$ = config.pipelines$;
    this.cachedPipeline$ = config.currentPipeline$;
    this.form = formBuilder.group({
      stage: [],
    });
  }

  ngOnInit(): void {
    this.subscriptionList.add(this.cachedPipeline$, (cachedPipeline) => {
      {
        const pipeline = cachedPipeline as Pipeline;
        this.selectPipeline(pipeline);
      }
    });
  }

  ngOnDestroy(): void {
    this.subscriptionList.destroy();
  }

  private emitSelection(pipeline: Pipeline, probability: number): void {
    this.pipelineValues.emit(<OpportunityValues>{ pipelineId: pipeline.id, probability: probability });
  }

  selectStage(pipeline: Pipeline, probability?: number): void {
    probability = probability ?? pipeline.stages[0].probability; // default first stage
    this.form.controls.stage.setValue(probability);
    this.emitSelection(pipeline, probability);
  }

  selectPipeline(pipeline: Pipeline): void {
    this.selectedPipeline$$.next(pipeline);
    this.selectStage(pipeline);
  }
}
